import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import PlaceHolder from '../../portal/common/PlaceHolder';
import { serialize, WysiwygViewer } from '../wysiwyg/WysiwygEditor';
import { WysiwygProvider, WysiwygInPlaceEditor, EditorToolbar } from '../wysiwyg/WysiwygInPlaceEditor';
const RichTextWidget = ({ content, editData, configId, limitToPageWidth, disabled, }) => {
    const isEmpty = () => (editData && (content && (content.slate === undefined || (content.slate[0].children[0].text === '' && content.slate[1] === undefined))));
    if (isEmpty() && editData.activeConfigId !== configId) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Rich Text Layout" }));
    }
    if (!editData || editData.activeConfigId !== configId || disabled) {
        return (_jsx(WysiwygViewer, { id: configId, value: content.slate }));
    }
    return (_jsx(Stack, { sx: {
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsx(WysiwygInPlaceEditor, { id: configId }) }));
};
RichTextWidget.meta = {
    group: 'design',
    name: 'Rich Text',
    sort: 10,
    description: 'Directly enter text to display',
    props: [
        {
            key: 'content',
            name: 'Text',
            description: 'The text to display',
            type: 'richtext',
            // means the value is managed by the widget code itself
            // and should be managed in the property panel.
            inPlaceEdit: true,
            group: 'style',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'RichTextWidget',
        props: {
            limitToPageWidth: true,
            content: {
                slate: undefined,
                html: '<div>&nbsp;</div>',
            },
        },
    },
};
RichTextWidget.IpeWrapper = ({ configId, config, editData, disabled, children, }) => {
    // console.log('ipewrapper', { configId, config });
    if (!editData || editData.activeConfigId !== configId || disabled) {
        return children;
    }
    console.log('doing provider for configId', configId);
    return (_jsx(WysiwygProvider, { id: configId, value: config.props?.content?.slate, setValue: (newValue) => {
            const newContent = {
                slate: newValue,
                html: serialize(newValue),
            };
            editData.actions.updateConfigValue(configId, 'props.content', newContent);
        }, children: children }));
};
RichTextWidget.ipeControls = (_jsx(EditorToolbar, {}));
export default RichTextWidget;
//# sourceMappingURL=RichTextWidget.js.map